<template>
    <Layout :footer="footer">
        <app-head :noindex="noindex" :title="title"/>

        <div class="col-lg-7 col-10 mx-auto" :id="'pag-page-' + id">
            <div class="px-6 pt-3 mt-2 mt-lg-5 text-center">
                <component :is="header_tag" class="mb-4 mb-lg-2 fw-bold text-center">
                    {{ header }}
                </component>
                <em>
                    <h3 v-if="subtitle.length">{{ subtitle }}</h3>
                </em>
            </div>
        </div>

        <div class="col-lg-7 col-10 mx-auto">
            <div class="px-6 pt-3 mt-2 mt-lg-3">
                <slot></slot>
            </div>
        </div>

        <bottom-floating-bar></bottom-floating-bar>
    </Layout>
</template>

<script>

import AppHead from "./AppHead";
import Layout from "./Layout";
import WhatsappFloatingButton from "./Index/WhatsappFloatingButton";
import BottomFloatingBar from "./Index/BottomFloatingBar.vue";
export default {
    components: {BottomFloatingBar, WhatsappFloatingButton, Layout, AppHead},

    props: {
        title: {required: true},
        header: {required: true},
        header_tag: {default: 'h1'},
        subtitle: {required: false, default: ''},
        id: {required: true},
        noindex: {default: false},
        footer: {default: true},
    },

    mixins: [],

    data: function () {
        return {
            //
        };
    },

    computed: {
        //
    },

    created() {
        //
    },

    mounted() {
        //
    },

    methods: {
        //
    },

    watch: {
        //
    }
};
</script>
